function hillslope_community_layer(filter, level = ''){
    const community_auto_monitor = ajax_call("geojson/community_auto_monitor.json")
	var this_Icon = {
	    iconUrl: '',
	    iconAnchor:   [15, 32],
	    iconSize:     [32, 32],
	    popupAnchor:  [0, -20]
	}
	var hillslope_data = ajax_call(publicPath + "/napi/obs/hillslopecommunity/basic")
	var obs_hillslope_data = ajax_call(publicPath + "/napi/obs/hillslopecommunity/iot_device_stn_list")
	var geojson = {type: "FeatureCollection", features: []}, 
        rain_object = {},
        risk_level_mapping = {
            "L": "低風險", "M": "中風險", "H": "高風險"  
        }
	if (raw_data["雨量站"] == undefined) {
		raw_data["雨量站"] = rain_cwb()[1]
	}
	raw_data["雨量站"].forEach(function(element){
		rain_object[element.STID] = element
	})
	hillslope_data.forEach(function(element, index){
        element.level_abc = null_Converter(element.level_abc)
        element.urbanplan = null_Converter(element.urbanplan)
        element.use_license = null_Converter(element.use_license)
        element.obs_sensor = obs_hillslope_data[element.name]
        element.level_risk = risk_level_mapping[element.level_risk] || '其他'
        geojson.features.push({
            "type": "Feature",
            "geometry": {
                "type": "Point",
                "coordinates": [element.lon, element.lat]
            },
            "properties": element
        });
	});
	var this_layer = L.geoJSON(geojson, {
	  	pointToLayer: function(feature, latlng) {
	  		var this_feature_properties = feature.properties,
                show = true
            switch(this_feature_properties.level_risk){
                case "中風險":
                    this_Icon["iconUrl"] = "marker_icon/hillslope_community_y.png"
                    break
	  			case "高風險":
	  				this_Icon["iconUrl"] = "marker_icon/hillslope_community_r.png"
                    break
                default:
                    this_Icon["iconUrl"] = "marker_icon/hillslope_community_g.png"
	  		};
            if (community_auto_monitor.map(el => el.name).includes(feature.properties.name)) {
                this_Icon["iconUrl"] = "marker_icon/hillslope_community_auto_monitor.png"
            }
            if (filter) {
                if (filter.region !== "all") {
                    if (filter.region !== this_feature_properties.district) {
                        show = false
                    }
                }
            }
            if (show) {
                return L.marker(latlng, {
                    icon: new L.icon(this_Icon)
                })
            }
            
	  	},
        filter: function(feature, latlng) {
            if (level !== '') return feature.properties.level_abc == level
            else return feature
        }
	}).addTo(map);
	this_layer.on('click', onClick);
	function onClick(e){
		var this_marker = e.layer.feature.properties;
		var this_rain_sta_start_time = sql_query_start_time(rain_object[this_marker.rainstn_refer]?.TIME);
		var rain_sql_query_sta = publicPath + "/napi/obs/rainobs?STID=" + this_marker.rainstn_refer + "&StartTime=" + (this_rain_sta_start_time ?? '') + "&EndTime=" + (rain_object[this_marker.rainstn_refer]?.TIME.slice(0,16) ?? '');
		
        var obs_div = "", now_event_div = "", history_event_div = ""
		if (obs_hillslope_data[this_marker.name]) {
			obs_div =
				'<div class="col-12 mt-3">'+
					'<h5 class="font-weight-bold">二、環境監測-現地物聯網設備</h5>'+
					'<div class="row">' +
						'<div class="col-6 h-400" id="obs_element_div_1"></div>'+
						'<div class="col-6 h-400" id="obs_element_div_2"></div>'+
						'<div class="col-6 h-400" id="obs_element_div_3"></div>'+
						'<div class="col-6 h-400" id="obs_element_div_4"></div>'+
					'</div>' +
				'</div>';
		};
		var now_event_list = [], history_event_list = [],
			buffered = turf.buffer(turf.point([this_marker.lon, this_marker.lat]), 500, {units: 'meters'}),
			ptsWithin_all = new geoJsonTemplate(),
			ptsWithin_serious = new geoJsonTemplate(),
			now_event_intersected = null
		if (emis_event_select) {
			ptsWithin_all = turf.pointsWithinPolygon(raw_data["event"][0], buffered),
			ptsWithin_serious = turf.pointsWithinPolygon(raw_data["event"][1], buffered);
			ptsWithin_all.features.forEach(function(element){
				now_event_list.push([element.properties.PRJ_ID, element.properties.DISA_NO]);
			});
			ptsWithin_serious.features.forEach(function(element){
				now_event_list.push([element.properties.PRJ_ID, element.properties.DISA_NO]);
				ptsWithin_all.features.push(element);
			});
			now_event_intersected = ajax_call_post(publicPath + "/napi/emis/search/emis_multiple_events", {
				query_target: now_event_list
			});
		}

		if (raw_data["history_data"] == undefined) {
			raw_data["history_data"] = {"type": "FeatureCollection", "features": []};
			var history_data = ajax_call(publicPath + "/napi/emis/ntc_all_cases?start=2017&end=2020");
			history_data.forEach(function(element){
				raw_data["history_data"]["features"].push({
					"type": "Feature",
					"geometry": {
				      	"type": "Point",
				      	"coordinates": [parseFloat(element.WGS_X), parseFloat(element.WGS_Y)]
					},
					"properties": element
				});
			});
		};
		var ptsWithin_all_history = turf.pointsWithinPolygon(raw_data["history_data"], buffered);
		ptsWithin_all_history.features.forEach(function(element){
			history_event_list.push([element.properties.PRJ_ID, element.properties.DISA_NO]);
		});
		var history_event_intersected = ajax_call_post(publicPath + "/napi/emis/search/emis_multiple_events", {
			query_target: history_event_list
		});

		if(now_event_intersected == null){
			now_event_div +=
			    '<tr>'+
    				'<td scope="col" colspan="5">-附近尚無災情-</th>'+
				'</tr>';
		} else {
			now_event_intersected.forEach(function(element, index){
				now_event_div +=
				    '<tr>'+
	    				'<td scope="col">' + (index+1) +'</td>'+
	    				'<td scope="col">' + element.RPT_TIME +'</td>'+
	    				'<td scope="col">' + condition_status_type(element.STATUS) +'</td>'+
	    				'<td scope="col">' + element.DISA_LOCATION +'</td>'+
	    				'<td scope="col">' + element.SITUATION +'</td>'+
					'</tr>';
			});
		};

		if(history_event_intersected == null){
			history_event_div +=
			    '<tr>'+
    				'<td scope="col" colspan="5">-附近尚無災情-</th>'+
				'</tr>';
		} else {
			history_event_intersected.forEach(function(element, index){
				history_event_div +=
				    '<tr>'+
	    				'<td scope="col">' + (index+1) +'</td>'+
	    				'<td scope="col">' + element.RPT_TIME +'</td>'+
	    				'<td scope="col">' + condition_status_type(element.STATUS) +'</td>'+
	    				'<td scope="col">' + element.DISA_LOCATION +'</td>'+
	    				'<td scope="col">' + element.SITUATION +'</td>'+
					'</tr>';
			});
		};

		modal_open(
            '<ul class="nav nav-tabs mb-2" role="tablist">' +
                '<li class="nav-item w-50">' +
                    '<a class="p-cursor nav-link text-center active" data-toggle="tab" data-target="#hillslope-community-info-modal-basic" role="tab">社區基本資訊</a>' +
                '</li>' +
                '<li class="nav-item w-50">' +
                    '<a class="p-cursor nav-link text-center" data-toggle="tab" data-target="#hillslope-community-info-modal-safelist" role="tab" id="hillslope-community-info-modal-safelist-trig">安全檢查表(工務局)</a>' +
                '</li>' +
            '</ul>' +
            '<div class="tab-content">' +
                '<div class="tab-pane fade show active" id="hillslope-community-info-modal-basic" role="tabpanel">' +
                    '<div class="row">'+
                        '<div class="col-6 mb-2">'+
                            '<h5 class="font-weight-bold">一、社區資料</h5>'+
                            '<table class="table table-bordered text-center">'+
                                '<tbody>'+
                                    '<tr>'+
                                        '<th scope="col">行政區</th>'+
                                        '<td scope="col" colspan="3">' + this_marker.district + '</td>'+
                                    '</tr>'+
                                    '<tr>'+
                                        '<th scope="col">地址</th>'+
                                        '<td scope="col" colspan="3">' + this_marker.address + '</td>'+
                                    '</tr>'+
                                    '<tr>'+
                                        '<th scope="col">面積</th>'+
                                        '<td scope="col" colspan="3">' + this_marker.area_ha.toFixed(2) + '公頃</td>'+
                                    '</tr>'+
                                    '<tr>'+
                                        '<th scope="col">綜合風險</th>'+
                                        '<td scope="col" colspan="3">' + this_marker.level_risk + '</td>'+
                                    '</tr>'+
                                    '<tr>'+
                                        '<th scope="col">社區分級</th>'+
                                        '<td scope="col" colspan="3">' + this_marker.level_abc + '</td>'+
                                    '</tr>'+
                                    '<tr>'+
                                        '<th scope="col">使用執照</th>'+
                                        '<td scope="col" colspan="3">' + this_marker.use_license + '</td>'+
                                    '</tr>'+
                                    '<tr>'+
                                        '<th scope="col">地層</th>'+
                                        '<td scope="col" colspan="3">' + this_marker.geology + '</td>'+
                                    '</tr>'+
                                    '<tr>'+
                                        '<th scope="col">岩性說明</th>'+
                                        '<td scope="col" colspan="3">' + this_marker.litho + '</td>'+
                                    '</tr>'+
                                '</tbody>'+
                            '</table>'+
                        '</div>'+
                        `${community_auto_monitor.map(el => el.name).includes(this_marker.name) ? 
                            `<div class="col-6 mb-2">
                                <h5 class="font-weight-bold">二、近期歷史觀測歷線</h5>
                                <div class="h-300 w-100" id="auto_monitor_chart"></div>
                            </div>` :
                            `<div class="col-6 mb-2">
                                <h5 class="font-weight-bold">二、環境監測-鄰近雨量測站(${this_marker.rainstn_refer})</h5>
                                <div class="w-100 h-400" id="rain_div_chart"></div>
                            </div>`
                        }`+
                        obs_div +
                        '<div class="col-6 mb-4">'+
                            '<h5 class="font-weight-bold">三、街景影像</h5>'+
                            '<div class="w-100 h-350" id="panorama_container"></div>'+
                        '</div>'+
                        '<div class="col-6 mb-4">'+
                            '<h5 class="font-weight-bold">四、地理位置</h5>'+
                            '<div class="w-100 h-350" id="modal_map"></div>'+
                        '</div>'+
                        '<div class="col-12 mb-2">'+
                            '<h5 class="font-weight-bold">五、鄰近區域的災情紀錄</h5>'+
                            '<table class="table table-bordered text-center">'+
                                '<tbody>'+
                                    '<tr class="bg-dark text-white">'+
                                        '<td class="text-left font-weight-bold" colspan="5">(1)目前災情：共' + ptsWithin_all.features.length + '筆</td>'+
                                    '</tr>'+
                                    '<tr>'+
                                        '<th scope="col">序號</th>'+
                                        '<th scope="col">時間</th>'+
                                        '<th scope="col">狀態</th>'+
                                        '<th scope="col">地址</th>'+
                                        '<th scope="col">災情敘述</th>'+
                                    '</tr>'+
                                    now_event_div +
                                    '<tr class="bg-dark text-white">'+
                                        '<td class="text-left font-weight-bold" colspan="5">(2)歷史災情：共' + ptsWithin_all_history.features.length + '筆</td>'+
                                    '</tr>'+
                                    '<tr>'+
                                        '<th scope="col">序號</th>'+
                                        '<th scope="col">時間</th>'+
                                        '<th scope="col">狀態</th>'+
                                        '<th scope="col">地址</th>'+
                                        '<th scope="col">災情敘述</th>'+
                                    '</tr>'+
                                    history_event_div +
                                '</tbody>'+
                            '</table>'+
                        '</div>'+
                    '</div>' +
                '</div>' +
                '<div class="tab-pane fade" id="hillslope-community-info-modal-safelist" role="tabpanel">' +
                    '<div class="row">' +
                        '<div class="col-7">' +
                            `<div class="row">
                                <div class="col-4 border-right">
                                    <div class="nav flex-column nav-pills" role="tablist" aria-orientation="vertical">
                                        <a id="hillslope-community-info-modal-safelist-n-tab" class="nav-link active" data-toggle="pill" data-target="#hillslope-community-info-modal-safelist-n-content" role="tab">自然邊坡</a>
                                        <a id="hillslope-community-info-modal-safelist-m-tab" class="nav-link" data-toggle="pill" data-target="#hillslope-community-info-modal-safelist-m-content" role="tab">人工邊坡</a>
                                        <a id="hillslope-community-info-modal-safelist-d-tab" class="nav-link" data-toggle="pill" data-target="#hillslope-community-info-modal-safelist-d-content" role="tab">截排水設施</a>
                                        <a id="hillslope-community-info-modal-safelist-b-tab" class="nav-link" data-toggle="pill" data-target="#hillslope-community-info-modal-safelist-b-content" role="tab">建築物及路面</a>
                                    </div>
                                    <p class="mt-3 text-muted">圖例說明：自然邊坡<i class="fas fa-caret-up"></i>; 人工邊坡<i class="fas fa-minus"></i>; 截排水設施<i class="fas fa-ellipsis-h"></i>; 建築物及路面<i class="fas fa-circle"></i></p>
                                    <p class="text-muted">*註：徵兆等級說明：一級: 紅色; 二級: 黃色; 三級: 綠色</p>
                                </div>
                                <div class="col-8">
                                    <div class="tab-content">
                                        <div class="tab-pane fade show active" id="hillslope-community-info-modal-safelist-n-content" role="tabpanel"></div>
                                        <div class="tab-pane fade" id="hillslope-community-info-modal-safelist-m-content" role="tabpanel"></div>
                                        <div class="tab-pane fade" id="hillslope-community-info-modal-safelist-d-content" role="tabpanel"></div>
                                        <div class="tab-pane fade" id="hillslope-community-info-modal-safelist-b-content" role="tabpanel"></div>
                                    </div>
                                </div>
                            </div>` +
                        '</div>' +
                        '<div class="col-5">' +
                            '<div class="w-100 h-400" id="modal_map_safelist"></div>' +
                        '</div>' +
                    '</div>' +
                '</div>' +
            '</div>',
			'<i class="fas fa-book-open"></i>「' + (community_auto_monitor.find(el => el.name === this_marker.name)?.name || this_marker.name) + '」山坡地社區情資',
			function () {
				var panorama = new google.maps.StreetViewPanorama(
					document.getElementById('panorama_container'), {
					position: {
						lat: parseFloat(this_marker.lat),
						lng: parseFloat(this_marker.lon)
					},
					pov: { heading: 165, pitch: 0 }
				});
				var modal_map = new L.Map('modal_map', {
					attributionControl: false,
					zoomControl: false,
					center: new L.LatLng(this_marker.lat, this_marker.lon),
					zoom: 16,
					zoomSnap: 1,
					layers: L.tileLayer('https://{s}.google.com/vt/lyrs=p&x={x}&y={y}&z={z}',{
						maxZoom: 22,
						subdomains:['mt0','mt1','mt2','mt3'],
						opacity: 0.8
					})
				});
				L.marker([this_marker.lat, this_marker.lon]).addTo(modal_map);
				L.geoJSON(ptsWithin_all_history, {
					pointToLayer: function(feature, latlng) {
						return L.marker(latlng, {
							  icon: new L.icon({
								iconUrl: 'marker_icon/modal_event_history.png',
								iconAnchor:   [15, 32],
								iconSize:     [32, 32],
								popupAnchor:  [0, -20]
							})
						}).bindPopup(            
							'<div class="w-250">' +
								'<h5 class="font-weight-bold">鄰近社區的歷史災點</h5>'+
								'<h6>地址：' + feature.properties.DISA_LOCATION + '</h6>' + 
							'</div>');
					}
				}).addTo(modal_map);
				L.geoJSON(ptsWithin_all, {
					pointToLayer: function(feature, latlng) {
						return L.marker(latlng, {
							  icon: new L.icon({
								iconUrl: 'marker_icon/modal_event_now.png',
								iconAnchor:   [15, 32],
								iconSize:     [32, 32],
								popupAnchor:  [0, -20]
							})
						}).bindPopup(            
							'<div class="w-250">' +
								'<h5 class="font-weight-bold">目前鄰近社區的災情</h5>'+
								'<h6>時間：' + timeConverter(feature.properties.RPT_TIME) + '</h6>' + 
								'<h6>地址：' + feature.properties.DISA_LOCATION + '</h6>' + 
							'</div>');
					}
				}).addTo(modal_map);
				L.geoJSON(buffered, {
					style: {
						fill: false
					}
				}).addTo(modal_map);
				if (obs_div != "") {
					ajax_call_async(
						publicPath + "/napi/obs/hillslopecommunity/iot_device_data/" + obs_hillslope_data[this_marker.name].device_no,
						function(data){
							var obsArray = {
								rain: [],
								incline_x: [],
								incline_y: [],
								incline_z: [],
                                temp: [],
                                humi: []
							}
							data.reverse().forEach(el => {
								if (el["Rain"] === 65536) {
									el["Rain"] = null
								}
								if (el["Temp"] === 65536) {
									el["Temp"] = null
								}
                                if (el["Humi"] === 65536) {
									el["Humi"] = null
								}
								var this_row_time = time_sql_processing(el.time)
								obsArray.rain.push([this_row_time, el["Rain"]])
                                obsArray.temp.push([this_row_time, el["Temp"]])
                                obsArray.humi.push([this_row_time, el["Humi"]])
								obsArray.incline_x.push([this_row_time, el.incline_X])
								obsArray.incline_y.push([this_row_time, el.incline_Y])
								obsArray.incline_z.push([this_row_time, el.incline_Z])
							})
							all_series_chart_render({
								plot_type: "column",
								renderdiv: "obs_element_div_1",
								title: "雨量監測(單位：毫米)",
								series_name: ["10分鐘雨量"],
								data: [obsArray.rain],
								y_title: "降雨量(mm)",
								max: 40,
								min: 0
							});
							all_series_chart_render({
								plot_type: "spline",
								renderdiv: "obs_element_div_2",
								title: "傾斜儀監測(單位：度)",
								series_name: ["x軸", "Y軸", "Z軸"],
								data: [obsArray.incline_x, obsArray.incline_y, obsArray.incline_z],
								y_title: "度(°)"
							});
							all_series_chart_render({
								plot_type: "spline",
								renderdiv: "obs_element_div_3",
								title: "溫度監測(單位：°C)",
								series_name: ["溫度"],
								data: [obsArray.temp],
								y_title: "°C"
							});
							all_series_chart_render({
								plot_type: "spline",
								renderdiv: "obs_element_div_4",
								title: "濕度監測(單位：%)",
								series_name: ["濕度"],
								data: [obsArray.humi],
								y_title: "%",
								max: 100,
								min: 0
							});
						},
						function(){}
					)
				};
                if (community_auto_monitor.map(el => el.name).includes(this_marker.name)) {
                    this_marker.name = community_auto_monitor.find(el => el.name === this_marker.name).name
                    let dataset = {'X軸': [], 'Y軸': []}
                    $.ajax({
                        url: publicPath + '/napi/obs/hillslopecommunity/get_incline_history_data',
                        dataType: 'json',
                        method: 'POST',
                        headers: {
                            Authorization: 'Bearer ' + localStorage.getItem('jwt_token')
                        },
                        async: false,
                        data: JSON.stringify({ id: community_auto_monitor.find(el => el.name === this_marker.name).data.split('=')[1] })
                    }).done(function(data){
                        data.forEach(function(el, index){
                            if (index % 5 === 0) {
                                dataset['X軸'].push([time_sql_processing(el.time), el.incline_X])
                                dataset['Y軸'].push([time_sql_processing(el.time), el.incline_Y])
                            }
                        })
                    })                    
                    Highcharts.stockChart({
                        chart: {
                            type: 'spline',
                            zoomType: 'x',
                            renderTo: 'auto_monitor_chart'
                        },
                        legend: {
                            enabled: true
                        },
                        navigator: {
                            enabled: false
                        },
                        rangeSelector: {
                            enabled: false
                        },
                        plotOptions: {
                            series: {
                                showInNavigator: true
                            }
                        },
                        exporting:{
                            enabled: false
                        },
                        series: [{
                            name: "傾斜計(X軸)",
                            data: dataset["X軸"],
                            tooltip: { valueDecimals: 2}
                        },{
                            name: "傾斜計(Y軸)",
                            data: dataset["Y軸"],
                            tooltip: { valueDecimals: 2}
                        }],
                        yAxis: [{
                            title: {
                                text: "度(°)"
                            }
                        }]
                    });
                } else {
                    if (!this_rain_sta_start_time) return
                    ajax_call_async(rain_sql_query_sta , function(data){
                        var rain_dataset = {
                            "hour": [], "hour_24": []
                        };
                        data.forEach(function(element){
                            var time = time_sql_processing(element.TIME);
                            rain_dataset["hour"].push([time, rain_value_processing(element.RAIN)]);
                            rain_dataset["hour_24"].push([time, rain_value_processing(element.HOUR_24)]);
                        });
                        var plot_object = Highcharts.stockChart({
                            chart: {
                                type: 'area',
                                zoomType: 'x',
                                renderTo: 'rain_div_chart'
                            },
                            legend: {
                                enabled: true
                            },
                            rangeSelector: {
                                enabled: false
                            },
                            plotOptions: {
                                series: {
                                    showInNavigator: true
                                }
                            },
                            exporting:{
                                enabled: false
                            },
                            series: [{
                                name: "近24小時雨量",
                                data: rain_dataset["hour_24"],
                                tooltip: { valueDecimals: 2}
                            },{
                                name: "時雨量",
                                data: rain_dataset["hour"],
                                tooltip: { valueDecimals: 2}
                            }],
                            yAxis: [{
                                title: {
                                    text: "降雨量(mm)"
                                }
                            }]
                        });
                    })
                }
                // 社區安全檢查表
                ajax_call_async(publicPath + "/napi/obs/hillslopecommunity/safelist/" + this_marker.code, function(data){
                    var layer = {},
                        layer_object = {},
                        safelist_level_risk_color = {
                            "一": "red", "二": "#FFBC42", "三": "#00ff23"
                        }
                    var modal_map_safelist = new L.Map('modal_map_safelist', {
                        attributionControl: false,
                        zoomControl: false,
                        center: new L.LatLng(this_marker.lat, this_marker.lon),
                        zoom: 16,
                        zoomSnap: 1,
                        layers: L.tileLayer('https://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}',{
                            maxZoom: 22,
                            subdomains:['mt0','mt1','mt2','mt3'],
                            opacity: 1
                        })
                    });
                    $("#hillslope-community-info-modal-safelist-trig").click(function(){
                        setTimeout(() => {
                            modal_map_safelist.invalidateSize(true)
                            modal_map_safelist.fitBounds(layer_object.area.getBounds())
                            setTimeout(() => {
                                modal_map_safelist.zoomOut()
                            }, 1000)
                        }, 1000)
                    })
                    // 安全檢查表資訊
                    Object.keys(data).forEach(eachKey => {
                        if (!layer[eachKey]) {
                            layer[eachKey] = turf.featureCollection([])
                        }
                        if (data[eachKey].length > 0) {
                            layer[eachKey].features.push(preProcessingData.pssqlGeojson(data[eachKey], 'geom'))
                        }
                    })
                    Object.keys(layer).forEach(eachKey => {
                        if (eachKey === "area") {
                            layer_object.area = L.geoJSON(layer.area, { color: "brown", weight: 3, fill: false, interactive: false }).addTo(modal_map_safelist)
                        } else {
                            var dom_key = eachKey.replace("_", "-")
                            if (layer[eachKey].features.length === 0) {
                                $("#hillslope-community-info-modal-" + dom_key + "-tab").append(`<span class="badge badge-danger ml-2">0處</span>`)
                                $("#hillslope-community-info-modal-" + dom_key + "-content").html('<p class="text-center">此社區無此類型風險項目。</p>')
                            } else {
                                var this_feature = layer[eachKey].features[0].features
                                var content_html = { tbody: "" }
                                $("#hillslope-community-info-modal-" + dom_key + "-tab").append(`<span class="badge badge-danger ml-2">${this_feature.length}處</span>`)
                                switch (dom_key) {
                                    case "safelist-n":
                                        content_html.thead = '<tr><th scope="col">#</th><th scope="col">邊坡類型</th><th scope="col">徵兆等級</th></tr>'
                                        this_feature.forEach((feature, index) => {
                                            content_html.tbody += `
                                                <tr>
                                                    <td>${(index+1)}</td>
                                                    <td>${feature.properties.hillslpoe_location}</td>
                                                    <td>${feature.properties.level_risk}</td>
                                                </tr>`
                                        })
                                        content_html.pointToLayer = function(feature, latlng) {
                                          return L.marker(latlng, {
                                                icon: new L.icon({
                                                    iconUrl: 'marker_icon/triangle_' + feature.properties.level_risk + '.png',
                                                    iconAnchor:   [9, 20],
                                                    iconSize:     [20, 20],
                                                    popupAnchor:  [0, -10]
                                                })
                                          })
                                        }
                                        break
                                    case "safelist-m":
                                        content_html.thead = '<tr><th scope="col">#</th><th scope="col">邊坡類型</th><th scope="col">徵兆等級</th></tr>'
                                        this_feature.forEach((feature, index) => {
                                            content_html.tbody += `
                                                <tr>
                                                    <td>${(index+1)}</td>
                                                    <td>${feature.properties.wall_category}</td>
                                                    <td>${feature.properties.level_risk}</td>
                                                </tr>`
                                        })
                                        content_html.style = function style(feature) {
                                            return {
                                                color: safelist_level_risk_color[feature.properties.level_risk],
                                            }
                                        }
                                        break
                                    case "safelist-d":
                                        content_html.thead = '<tr><th scope="col">#</th><th scope="col">溝渠類型</th><th scope="col">徵兆等級</th></tr>'
                                        this_feature.forEach((feature, index) => {
                                            content_html.tbody += `
                                                <tr>
                                                    <td>${(index+1)}</td>
                                                    <td>${feature.properties.drain_category}</td>
                                                    <td>${feature.properties.level_risk}</td>
                                                </tr>`
                                        })
                                        content_html.style = function style(feature) {
                                            return {
                                                color: safelist_level_risk_color[feature.properties.level_risk],
                                                dashArray: '3'
                                            }
                                        }
                                        break
                                    case "safelist-b":
                                        content_html.thead = '<tr><th scope="col">#</th><th scope="col">門牌號碼</th><th scope="col">建物類型</th><th scope="col">徵兆等級</th></tr>'
                                        this_feature.forEach((feature, index) => {
                                            content_html.tbody += `
                                                <tr>
                                                    <td>${(index+1)}</td>
                                                    <td>${feature.properties.address}</td>
                                                    <td>${feature.properties.building_category}</td>
                                                    <td>${feature.properties.level_risk}</td>
                                                </tr>`
                                        })
                                        content_html.pointToLayer = function(feature, latlng) {
                                            return L.marker(latlng, {
                                                  icon: new L.icon({
                                                      iconUrl: 'marker_icon/circle_' + feature.properties.level_risk + '.png',
                                                      iconAnchor:   [9, 20],
                                                      iconSize:     [20, 20],
                                                      popupAnchor:  [0, -10]
                                                  })
                                            })
                                        }
                                        break
                                }
                                $("#hillslope-community-info-modal-" + dom_key + "-content").html(`
                                    項目檢視
                                    <table class="table table-sm text-center table-bordered">
                                        <thead class="thead-dark">
                                            ${content_html.thead}
                                        </thead>
                                        <tbody>
                                            ${content_html.tbody}
                                        </tbody>
                                    </table>`
                                )
                                layer_object[eachKey] = L.geoJSON(this_feature, { 
                                    pointToLayer: content_html.pointToLayer,
                                    onEachFeature: content_html.onEachFeature,
                                    style: content_html.style
                                }).addTo(modal_map_safelist)
                            }
                        }
                    })
                })
			}
		);
	};
  	var result = [this_layer, hillslope_data];
	return result;
}

function hillslope_pinlin_construction_layer(){
	var this_Icon = {
	    iconUrl: 'marker_icon/hillslope_community_g.png',
	    iconAnchor:   [15, 32],
	    iconSize:     [32, 32],
	    popupAnchor:  [0, -20]
	}
    var obsData = ajax_call(publicPath + "/napi/obs/hillslopecommunity/pinlin/lastest")
    var eti1 = turf.point([121.71206098, 24.93847188], { instrument_type: "ETI-1", description: "構造物傾斜計1" })
    var eti2 = turf.point([121.71183925, 24.93923828], { instrument_type: "ETI-2", description: "構造物傾斜計2" })
    var geojson = turf.featureCollection([eti1, eti2])
	var this_layer = L.geoJSON(geojson, {
        pointToLayer: function(feature, latlng) {
            feature.properties.data = obsData[feature.properties.instrument_type]
            return L.marker(latlng, {
                icon: new L.icon(this_Icon)
            })
        }
    }).addTo(map).on("click", function(e){
        var this_marker = e.layer.feature.properties
        modal_open(`
            <div class="row">
                <div class="col-5">
                    <h5 class="font-weight-bold">一、基本資訊與最新觀測數據</h5>
                    <table class="table table-sm table-bordered text-center">
                        <tbody>
                            <tr>
                                <th scope="col">站名</th>
                                <td scope="col">${this_marker.description}</td>
                            </tr>
                            <tr>
                                <th scope="col">站號</th>
                                <td scope="col">${this_marker.instrument_type}</td>
                            </tr>
                            <tr>
                                <th scope="col" rowspan="3">最新觀測</th>
                                <td scope="col">時間: ${ this_marker.data ? this_marker.data[this_marker.instrument_type + "A"].timestamp : "-" }</td>
                            </tr>
                            <tr>
                                <td scope="col">傾斜計X軸: ${ this_marker.data ? (this_marker.data[this_marker.instrument_type + "A"].value / 3600).toFixed(2) : "-" }°</td>
                            </tr>
                            <tr>
                                <td scope="col">傾斜計Y軸: ${ this_marker.data ? (this_marker.data[this_marker.instrument_type + "B"].value / 3600).toFixed(2) : "-" }°</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="col-7">
                    <h5 class="font-weight-bold">二、近期歷史觀測歷線</h5>
                    <div class="h-300 w-100" id="pinlin_div_chart"></div>
                </div>
            </div>`,
            `「${this_marker.description}」坪林水保觀測站`,
            function(){
                ajax_call_async(publicPath + "/napi/obs/hillslopecommunity/pinlin/history/" + this_marker.instrument_type + "/" + get_time_string(24*7).slice(0,10) + "/" + get_time_string(-24).slice(0,10), function(data){
					var dataset = {}
                    Object.keys(data).forEach(eachKey => {
                        dataset[eachKey] = []
                        data[eachKey].forEach(el => {
                            dataset[eachKey].push([time_sql_processing(el.timestamp), (el.value / 3600)])
                        })
                    })
                    console.log(dataset)
					Highcharts.stockChart({
						chart: {
							type: 'spline',
							zoomType: 'x',
							renderTo: 'pinlin_div_chart'
						},
						legend: {
							enabled: true
						},
                        navigator: {
                            enabled: false
                        },
						rangeSelector: {
							enabled: false
						},
						plotOptions: {
							series: {
								showInNavigator: true
							}
						},
						exporting:{
							enabled: false
						},
						series: [{
							name: "傾斜計(X軸)",
							data: dataset["X軸"],
							tooltip: { valueDecimals: 2}
						},{
							name: "傾斜計(Y軸)",
							data: dataset["Y軸"],
							tooltip: { valueDecimals: 2}
						}],
						yAxis: [{
							title: {
								text: "度(°)"
							}
						}]
					});
                })
            }
        )
    })
    var result = [this_layer, geojson];
	return result;
}
